export function insiderTradingsHasActivity(insiderTradings) {
  if (!insiderTradings || insiderTradings.length === 0) {
    return false;
  }

  return insiderTradings.some(
    (row) => Number(row.sum_acquistion) > 0 || Number(row.sum_disposition) > 0,
  );
}

export function politicianTransactionsHasActivity(politicianTransactions) {
  if (!politicianTransactions || politicianTransactions.length === 0) {
    return false;
  }

  return politicianTransactions.some(
    (row) => Number(row.count_buy) > 0 || Number(row.count_sell) > 0,
  );
}
